export default "__VITE_ASSET__DG0Qi_nO__"